// JWT-токен администратора. Хранится в sessionStorage (через zustand `persist`), НЕ localStorage —
// переживает reload вкладки, но не переживает закрытие вкладки/браузера (тот же принцип избегания
// долгоживущих секретов в браузере, что и у Mini App с initData, см. docs/PLAN.md Этап 6).
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface AuthState {
  token: string | null;
  setToken: (token: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      setToken: (token) => set({ token }),
      logout: () => set({ token: null }),
    }),
    {
      name: "avappbot-admin-auth",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
